import React, { useState, useEffect, use } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { DataGrid } from '@material-ui/data-grid';
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from '@material-ui/icons/Search';
import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper, Select, InputLabel, MenuItem, FormControl, makeStyles } from '@material-ui/core';
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../../_metronic/_assets/css/app.css';
import '../../../../_metronic/_assets/css/app2.css';

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
	formControl: {
	  margin: 0, //theme.spacing(1),
	  minWidth: 120,
	},
	formControlWide: {
	  margin: 0, //theme.spacing(1),
	  minWidth: '100%',
	},
	selectEmpty: {
	  marginTop: theme.spacing(2),
	},
	label: {
	  backgroundColor: '#fff',
	  paddingLeft: 3,
	  paddingRight: 3,
	}
  }));


export default function SurveyResults() {

  const [searchTerm, setSearchTerm] = useState('')
  const surveyResults = useSelector(state => state.admin.SurveyResults)
  const filters = useSelector(state => state.admin.Filters)
  const dispatch = useDispatch()
  const classes = useStyles();
  useEffect( () => { dispatch(Admin.actions.fetchSurveyResults()) }, [dispatch] )

  const searchSurveyResult = (result) => {
    if( true
        && ((result.fullname && result.fullname.toLowerCase().search(searchTerm.toLowerCase()) > -1) || (searchTerm.length === 0))
        && (filters.surveyResponseStatus === 'All' || (filters.surveyResponseStatus === 'Complete' && result.status === 'Complete') || (filters.surveyResponseStatus === 'Abandoned' && result.status === 'Abandoned') || (filters.surveyResponseStatus === 'Not Started' && result.status === 'Not Started') || (filters.surveyResponseStatus === 'In Progress' && result.status === 'In Progress') || (filters.surveyResponseStatus === 'Cancelled' && result.status === 'Cancelled')) 
      )
    {
      return result
    }  
  }
  const filteredSurveyResults = surveyResults.filter(result => searchSurveyResult(result))



  var [show, setShow] = useState(false);
  var [currentSurveyResultsID,setCurrentSurveyResultsID] = useState(0);
  var [currentFullname,setCurrentFullname] = useState('');
  var [currentEmail,setCurrentEmail] = useState('');
  var [currentMobilephone,setCurrentMobilephone] = useState('');
  var [currentStatus,setCurrentStatus] = useState('');
  var [currentCreated,setCurrentCreated] = useState('');
  var [currentPlatformExperience,setCurrentPlatformExperience] = useState(0);
  var [currentProviderExperience,setCurrentProviderExperience] = useState(0);
  var [currentExperienceComments,setCurrentExperienceComments] = useState('');
  var [currentHelpLevel,setCurrentHelpLevel] = useState(0);
  var [currentCost,setCurrentCost] = useState('');
  var [currentShared,setCurrentShared] = useState('');

  const loadSurveyResultsDetail = (thisSurveyResponse) => {
    setCurrentSurveyResultsID(thisSurveyResponse.id)
    setCurrentFullname(thisSurveyResponse.fullname)
    setCurrentEmail(thisSurveyResponse.email)
    setCurrentMobilephone(thisSurveyResponse.mobilephone)
    setCurrentStatus(thisSurveyResponse.status)
    setCurrentCreated(thisSurveyResponse.created)
    setCurrentPlatformExperience(thisSurveyResponse.platformexperience)
    setCurrentProviderExperience(thisSurveyResponse.providerexperience)
    setCurrentExperienceComments(thisSurveyResponse.experienceComments)
    setCurrentHelpLevel(thisSurveyResponse.helplevel)
    setCurrentCost(thisSurveyResponse.cost)
    setCurrentShared(thisSurveyResponse.shared)
    setShow(true)
  }

  const columns = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'fullname', headerName: 'Name', width: 300,  
      renderCell: (params) => (
        <strong>
            <div onClick={() => loadSurveyResultsDetail(surveyResults.find(surveyResults => surveyResults.id === params.row.id))} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },
    { field: 'email', headerName: 'Email', width: 200 },
    { field: 'mobilephone', headerName: 'Mobile Phone', width: 150 },
    { field: 'created', headerName: 'Created', width: 150 },
    { field: 'status', headerName: 'Status', width: 120 },
    { field: 'platformexperience', headerName: 'Platform', width: 150 },
    { field: 'providerexperience', headerName: 'Provider', width: 150 },
    { field: 'experienceComments', headerName: 'Experience', width: 300 },
    { field: 'helplevel', headerName: 'Help Level', width: 150 },
    { field: 'cost', headerName: 'Cost', width: 150 },
    { field: 'shared', headerName: 'Share', width: 150 },

  ];

  
  function handleClose() {
    setShow(false);
  }  

  const handleSearch = (event) => {
    const searchTerm = event.target.value    
    setSearchTerm(searchTerm)
  }


  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h4 style={{ marginBottom: 12 }}>Survey Responses</h4></Grid>
      </Grid>

      <Paper> 
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm" >
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control                  
                  type="text"
                  value={searchTerm}
                  onChange={(event) => handleSearch(event)}
                  autoComplete='OFF'
                />
              </InputGroup>
          </Grid>
          <Grid item style={{ paddingRight: 10, paddingLeft: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="surveyResponseStatus-label" className={classes.label}>Status</InputLabel>
              <Select
                labelId="surveyResponseStatus-label"
                id="surveyResponseStatus"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.surveyResponseStatus}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: 'surveyResponseStatus', filterValue: event.target.value }))}
              >
                <MenuItem value='All'>All</MenuItem>
                <MenuItem value='Complete'>Complete</MenuItem>
                <MenuItem value='Abandoned'>Abandoned</MenuItem>
                <MenuItem value='Not Started'>Not Started</MenuItem>
                <MenuItem value='In Progress'>In Progress</MenuItem>
                <MenuItem value='Cancelled'>Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      { surveyResults ? 
        <Paper style={{ height: 700 }}>
          <DataGrid rows={filteredSurveyResults} columns={columns} pageSize={10} checkboxSelection={false} rowHeight={40} />
        </Paper>
      : ('None')
      }

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal" >
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Survey Result - {currentFullname} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contracts-modal">
          <Row>
            <Col md="9">
              <Form.Group >
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentFullname} disabled />
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group >
                <Form.Label>Created</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentCreated} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <Form.Group >
                <Form.Label>Email</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentEmail} disabled />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group >
                <Form.Label>Mobile Phone</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentMobilephone} disabled />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group >
                <Form.Label>Status</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentStatus} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <Form.Group >
                <Form.Label>Platform Experience</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentPlatformExperience} disabled />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group >
                <Form.Label>Provider Experience</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentProviderExperience} disabled />
              </Form.Group>
            </Col>
            <Col md="4">
              <Form.Group >
                <Form.Label>Help Level</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentHelpLevel} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form.Group >
                <Form.Label>Experience Comments</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentExperienceComments} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form.Group >
                <Form.Label>Cost</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentCost} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form.Group >
                <Form.Label>Shared with RHC?</Form.Label>
                <Form.Control type="text" name="Name" defaultValue={currentShared} disabled />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="contracts-modal">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>

      </Modal>

    </>
  )
}
